module.exports = __webpack_public_path__ + "media/images/google-1db47a0525327dfd6504d860a116b6bf.svg";